export const TYPES = [
  {
    id: 1,
    name: "scorm",
    value: 1,
    i18n: true,
    contentType: ".zip",
    maxSize: "1.5 GB",
    maxSizeInBytes: 524288000 * 3,
  },
  {
    id: 2,
    name: "video",
    value: 2,
    i18n: true,
    contentType: "video/*",
    maxSize: "1.5 GB",
    maxSizeInBytes: 524288000 * 3,
  },
  {
    id: 3,
    name: "pdf",
    value: 3,
    i18n: true,
    contentType: ".pdf",
    maxSize: "100 MB",
    maxSizeInBytes: 524288000 / 5,
  },
  {
    id: 4,
    name: "html",
    value: 4,
    i18n: true,
    contentType: null,
  },
  {
    id: 11,
    name: "googleform",
    value: 11,
    i18n: true,
    contentType: null,
  },
];
